<template>
  <div class="card card-body card-panel-box border-0 m-3">
    <div class="row d-flex justify-content-start">
      <h3 style="font-size: 1.2vw !important;"> ماتریس نقش ها و مسئولیت ها(RACI)
      </h3>
      <hr>
    </div>

    <div class="table-responsive">
      <center v-show="!all_items.length">
        مشخصات فعالیت های فرآیند وجود ندارد
      </center>
      <table class="table table-striped" v-show="all_items.length">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>عنوان فعالیت</th>
          <th>مجری</th>
          <th>تایید کننده</th>
          <th>مشاور</th>
          <th>مطلع</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in all_items">
          <td scope="row">{{ index + 1 }}</td>
          <td>{{ item.title }}</td>
          <td>
            <span @click="allUsersMethod(item.id)" style="color: #0d6efd; cursor: pointer;">مشاهده</span>
          </td>
          <td v-if="item.seconder">{{ item.seconder.name }}</td>
          <td v-else>
            <center>
              <button @click.prevent="showListInserter(item.id)" class="btn btn-primary btn-submit-1">افزودن</button>
            </center>
          </td>
          <td v-if="item.consultant">{{ item.consultant.name }}</td>
          <td v-else>
            <center>
              <button @click.prevent="showListInserter2(item.id)" class="btn btn-primary btn-submit-1">افزودن</button>
            </center>
          </td>
          <td v-if="item.beginning">{{ item.beginning.name }}</td>
          <td v-else>
            <center>
              <button @click.prevent="showListInserter3(item.id)" class="btn btn-primary btn-submit-1">افزودن</button>
            </center>
          </td>


        </tr>

        </tbody>
      </table>
    </div>
  </div>
  <!-- ************************************** -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 80%;">
    <div>
      <p>تایید کننده </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item_${item.id}`" v-model="inserterId" type="radio" name="parent" :value="item['id']"></td>
          <td><label :for="`item_${item.id}`">{{ item['id'] }}</label></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_inserterMethod(item_id)">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter2"
       style="z-index: 999999999999999999999999999999999999999999999; top: 80%;">
    <div>
      <p>مشاور </p>
      <p @click="select_inserter2=!select_inserter2">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item3_${item.id}`" v-model="inserterId2" type="radio" name="parent" :value="item['id']"></td>
          <td><label :for="`item3_${item.id}`">{{ item['id'] }}</label></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_inserterMethod2(item_id)">تایید</button>
    </div>
  </div>


  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter3"
       style="z-index: 999999999999999999999999999999999999999999999; top: 80%;">
    <div>
      <p>مطلع </p>
      <p @click="select_inserter3=!select_inserter3">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item2_${item.id}`" v-model="inserterId3" type="radio" name="parent" :value="item['id']"></td>
          <td><label :for="`item2_${item.id}`">{{ item['id'] }}</label></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_inserterMethod3(item_id)">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 28%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p> خطا </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{ errorMessage }}


      <button @click="error=!error">بازگشت</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="allUserModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 77%;">
    <div>
      <p>   متولی  </p>
      <p @click="allUserModal=!allUserModal">❌</p>
    </div>
    <div>
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>پست سازمانی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allUser" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item.organizationposts.name }}</td>
          <td>{{ item.organizationposts.curator.fullname }}</td>
        </tr>

        </tbody>
      </table>
      </div>



      <button @click="allUserModal=!allUserModal">بازگشت</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";

export default {
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      all_inserter: [],
      allUser: [],
      select_inserter: false,
      allUserModal: false,
      select_inserter2: false,
      select_inserter3: false,
      deleteModal: false,
      editModal: false,
      search_inserter: '',
      inserterId: '',
      inserterId2: '',
      inserterId3: '',
      inserterName: '',
      inserterNam2: '',
      inserterNam3: '',
      title: '',
      type: '',
      time: '',
      frequency: '',
      prerequisite: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,

    }
  },


  methods: {
    allUsersMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/show_or/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.allUser.length=0
              response.all.forEach((item)=>{
                this.allUser.push(item)
              })
              this.allUserModal = true
            }




          })
          .catch();
    },
    deleteModalMethod(id) {
      this.item_id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal = false


          })
          .catch();
    },
    edit(id) {
      this.item_id = id
      this.editModal = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item) {
              this.title = item.title
              this.time = item.average_time
              this.frequency = item.frequency
              this.prerequisite = item.prerequisite
              this.inserterName = item.organizationpost.name
              this.inserterId = item.organizationpost.id

            }


          })
          .catch();
    },
    update(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('organizationposts_id', this.inserterId)
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId = ''
            this.title = ''
            this.inserterName = ''
            this.editModal = false
            this.title = ''
            this.time = ''
            this.frequency = ''
            this.prerequisite = ''
            this.inserterName = ''
            this.inserterId = ''


          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      formdata.append('organizationposts_id', this.inserterId)
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('average_time', this.time)
      formdata.append('frequency', this.frequency)
      formdata.append('prerequisite', this.prerequisite)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.addToSharedList()
            this.showItem()
            this.inserterId = ''
            this.title = ''
            this.inserterName = ''
            this.title = ''
            this.time = ''
            this.frequency = ''
            this.prerequisite = ''
            this.inserterName = ''
            this.inserterId = ''

          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************
    ...mapMutations(['setSharedList']),
    addToSharedList() {
      this.setSharedList(true);

    },
    showListInserter(id) {
      this.item_id=id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)

              })
                this.select_inserter = true

            }

          })
          .catch();
    }, showListInserter2(id) {
      this.item_id=id

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)

              })

                this.select_inserter2= true
            }

          })
          .catch();
    }, showListInserter3(id) {
      this.item_id=id

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)

              })
                this.select_inserter3 = true

            }

          })
          .catch();
    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.all_items.length = 0
              response.all.forEach((item) => {
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },
    select_inserterMethod(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('seconder_id', this.inserterId)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update_other/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()



          })
          .catch();

      this.select_inserter = false


    }, select_inserterMethod2(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('consultant_id', this.inserterId2)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update_other/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()



          })
          .catch();

      this.select_inserter2 = false


    }, select_inserterMethod3(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('beginning_id', this.inserterId3)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/tasks_process/update_other/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()



          })
          .catch();

      this.select_inserter3 = false


    },



  },
  watch: {
    statusInformation: function (newStatus) {
      if (newStatus) {
        this.showItem()
      } else {
        // انجام کارهای دیگر در صورت تغییر وضعیت به False
      }
    },
  },
  computed: {
    all() {
      return all
    },
    ...mapState(['statusInformation']),
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  }

}

</script>
<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}

</style>